import { render, staticRenderFns } from "./combat_matchRow_table.vue?vue&type=template&id=5762ac1a&scoped=true"
import script from "./combat_matchRow_table.vue?vue&type=script&lang=js"
export * from "./combat_matchRow_table.vue?vue&type=script&lang=js"
import style0 from "./combat_matchRow_table.vue?vue&type=style&index=0&id=5762ac1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762ac1a",
  null
  
)

export default component.exports